import { useMemo } from "react";


export function useTestimonialSchema(testimonials) {
  return useMemo(() => {
    if (!testimonials || testimonials.length === 0) return null;

    const extractTextFromRichText = (raw) => {
      try {
        const json = typeof raw === "string" ? JSON.parse(raw) : raw;
        if (!json || !json.content) return "";
        const getText = (nodes) =>
          nodes
            .map((node) => {
              if (node.nodeType === "text") return node.value;
              if (node.content) return getText(node.content);
              return "";
            })
            .join(" ");
        return getText(json.content).replace(/\s+/g, " ").trim();
      } catch (e) {
        return "";
      }
    };

    const organizationName = "Digitup Solution Pvt Ltd";

    const reviews = testimonials.map((t) => ({
      "@type": "Review",
      "author": {
        "@type": "Person",
        "name": t.name || "Anonymous",
      },
      "reviewBody": extractTextFromRichText(t.description?.raw || t.description || ""),
      "reviewRating": {
        "@type": "Rating",
        "ratingValue": t.rating ? String(t.rating) : "5",
        "bestRating": "5"
      },
      "itemReviewed": {
        "@type": "Organization",
        "name": organizationName
      },
      "datePublished": t.date || ""
    }));

    const ratings = testimonials.map((t) => Number(t.rating || 5));
    const averageRating = (ratings.reduce((a, b) => a + b, 0) / ratings.length).toFixed(1);

    return {
      "@context": "https://schema.org",
      "@type": "Organization",
      "name": organizationName,
      "aggregateRating": {
        "@type": "AggregateRating",
        "ratingValue": averageRating,
        "reviewCount": ratings.length.toString(),
        "bestRating": "5"
      },
      "review": reviews
    };
  }, [testimonials]);
}

